import React, { useState } from 'react';
import '../styles/mobileNav.css';
import MobileDropdown from './MobileDropdown';

const navItems = [
  { label: 'Home', icon: '🏠', menu: null },
  { label: 'Talent', icon: '👤', menu: 'talent' },
  { label: 'Media', icon: '🎥', menu: 'media' },
  { label: 'Brand Solutions', icon: '💼', menu: 'brand-solutions' },
  { label: 'Community', icon: '🌐', menu: 'community' },
];

const menuContents = {
  talent: ['Discovery', 'Portfolio', 'MasterClass', 'Awards', 'Opportunities', 'Projects'],
  media: ['Updates', 'Streaming', 'Spotlight', 'Podcast', 'Blogs', 'Testimonials'],
  'brand-solutions': [
    'Advertising & PR', 'Marketing Packages', 'Celebrity Campaigns', 'Brand Ambassadors',
    'Digital Marketing', 'Social Media Management', 'Content Production'
  ],
  community: ['FlourishTalents Club', 'Exclusive Offers', 'Events', 'Merchandise']
};

const MobileNav = () => {
  const [activeMenu, setActiveMenu] = useState(null);

  const handleClick = (menu) => {
    setActiveMenu(prev => (prev === menu ? null : menu));
  };

  return (
    <>
      <ul className="mobile-bottom">
        {navItems.map((item) => (
          <li
            key={item.label}
            className="mobile-bottom-item"
            onClick={() => item.menu && handleClick(item.menu)}
          >
            <div>{item.icon}</div>
            <span>{item.label}</span>
          </li>
        ))}
      </ul>

      {activeMenu && (
        <MobileDropdown items={menuContents[activeMenu]} onClose={() => setActiveMenu(null)} />
      )}
    </>
  );
};

export default MobileNav;
